
import { Client, ForgotPasswordRequest, PasswordResetRequest, AASTheme, UserProfile, UsersClient, Application, UpdateAccountRequest, LoggedInResponse } from '../clients/aasServerClient.generated';

// tslint:disable-next-line:variable-name
export function login(email: string, password: string, remember_me: boolean,
    task: string, url: string, application: string, queryString: string):
    Promise<{ admin: boolean, session: string }> {
        const client = new Client(process.env.PUBLIC_URL + '/api');
        return client.getCSRFToken().then(response => {
    return fetch(process.env.PUBLIC_URL + '/api/login', {
        body: JSON.stringify({ email, password, remember_me, task, url }),
        credentials: 'same-origin',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Pragma': 'no-cache',
            'csrf-token': response.csrfToken
        },
        method: 'POST',
    }).then((res) => {
        if (res.ok) {
            if (application && application !== "") {
                getSelfInfo().then(selfInfo => {
                    const app: Application | undefined = selfInfo.applications.find(
                        app =>
                            app.location_path.toLowerCase() ==
                            application.toLowerCase()
                    );
                    if (app) {
                        getApplicationToken(app.id).then(res => {
                            if (res.cheops)
                            {
                                localStorage.setItem('accessToken', res.token);
                                localStorage.setItem('core', `${res.anagoUrl}/core-api/v1`)
                                window.location.href = res.platformUrl
                            }
                            else
                            {
                                window.location.href = `${res.anagoUrl}?accessToken=${res.token}&aasUrl=${res.aasUrl}${queryString}`;
                            }
                        })
                        .catch(error =>{
                            const errWrapper = JSON.parse(error.response);
                            const err = errWrapper?.error || errWrapper;
                            if (err?.statusCode === 401 && err?.message === "MAINTENANCE_MODE" )
                            {
                                const msg = err?.extraMessage ? encodeURIComponent(err.message) : err?.message;
                                const baseUrl = process.env.PUBLIC_URL + "/select-app?errorMessage=MAINTENANCE_MODE";
                                const url = msg !== ""
                                    ? `${baseUrl}&extraMessage=${msg}`
                                    : baseUrl;
                                window.location.href = url;    
                                return;
                            }
                        });
                    } else {
                        window.location.href =
                          process.env.PUBLIC_URL + '/' +
                          'select-app?errorMessage=APPLICATION_NOT_FOUND';
                    }
                });
            } else if (task == "") {
                return res.json();
            } else {
                res.json().then((json) => {
                    if (json.url === ""){
                        window.location.href = process.env.PUBLIC_URL + "/select-app?missingPrivilege=true&errorMessage=MISSING_PRIVILEGES";
                    } else {
                        window.location.href = json.url + (json.url.includes("?") ? "&" : "?") +"jwt=" + json.token;
                    }
                });
            }
        } else {
            return res.text().then((err) => {
                // tslint:disable-next-line:no-any
                let json: any;
                try {
                    json = JSON.parse(err);
                } catch (e) {
                    json = { message: err };
                }
                if (task !== "" && json?.error?.redirectHost) {
                    var href = `https://${json?.error?.redirectHost}?task=${task ?? ''}&url=${url ?? ''}`;
                    window.location.replace(href);
                }
                return Promise.reject({
                    json,
                    status: res.status,
                    statusText: res.statusText,
                    text: err,
                });
            });
        }
    });
});
}

export function ssoLogin(task: string, url: string): void {
    var ssoUrl = `${process.env.PUBLIC_URL}/api/sso`;
    if (task || url) {
        ssoUrl += `?task=${task ?? ''}&redirectUrl=${url ?? ''}`;
    }
    window.location.replace(ssoUrl);
}

export function getProfile(): Promise<UserProfile> {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.getProfile();
}

export function getTheme(): Promise<AASTheme> {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.getSkin(window.location.host);
}
export function checkLogin(task: string, url: string, email: string, userName: string): Promise<LoggedInResponse> {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.loggedIn(window.location.host, task, url, email, userName);
}

export function loginAs(id: string): Promise<void> {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.postAlias(id);
}

export function logoutAs(): Promise<void> {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.removeAlias();
}

export function getUserPrivileges(id: string) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.getUserPrivileges(id);
}

export function getAssignPrivileges() {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.getAssignPrivileges();
}

export function ssoLogout() {
    window.location.replace(process.env.PUBLIC_URL + '/api/sso/logout');
}

export function logout() {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.logout();
}

export function sendPasswordReset(email: string) {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.forgotPassword(new ForgotPasswordRequest({ email }));
}

// tslint:disable-next-line:variable-name
export function resetPassword(id: string, token: string, new_password: string, confirm_new_password: string) {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.postPasswordReset(
        id, token,
        new PasswordResetRequest({
            confirmPassword: confirm_new_password,
            newPassword: new_password,
        })
    );
}

// tslint:disable-next-line:variable-name
export function confirmActiveDirectory(id: string, token: string) {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.postConfirmActiveDirectory(
        id, token,
    );
}

// tslint:disable-next-line:variable-name
export function verifyEmail(id: string, token: string) {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.verifyEmail(
        id, token, 
    );
}

export function checkResetPasswordToken(id: string, token: string) {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.checkPasswordResetToken(id, token);
}

export async function getApplicationToken(id: string) {
    const client = new Client(process.env.PUBLIC_URL + '/api');
        return await client.getApplicationToken(id);
}

export function getAbout() {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.getAbout();
}

export function getSessions() {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.getSessions();
}

export function getSelfInfo() {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.checkSelf();
}

export function updateAccount(email: string, confirmEmail: string, firstName: string, lastName: string) {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.updateAccount(
        new UpdateAccountRequest({
            confirm_email: confirmEmail, email,
            first_name: firstName, last_name: lastName
        }));
}

export function anonymousLogin(token: string) {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.checkAnonymousLoginToken(token);
}

export function getZendeskToken() {
    const client = new Client(process.env.PUBLIC_URL + '/api');
    return client.getZendeskToken();
}